export default "__VITE_ASSET__DlNRGaMl__"